import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["tagName", "htmlType"];
import { createVNode as h } from 'intact-react';
export var DynamicButton = function DynamicButton(_ref) {
  var tagName = _ref.tagName,
    htmlType = _ref.htmlType,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (props.href && tagName === 'button') {
    tagName = 'a';
  }
  if (tagName === 'button') {
    // set type of html button
    props = _extends({}, props, {
      type: htmlType
    });
  }
  return h(tagName, props);
};